import Home from '../components/Home';

const routes = [
  {
    name: 'Login',
    path: '/login',
    component: () => import('../views/login/index'),
  },
  {
    name: 'Home',
    path: '/',
    redirect: '/copyrightrun',
    component: Home,
    children: [
      {
        name: 'Copyrightrun',
        path: '/copyrightrun',
        component: () => import('../views/copyrightRun/index'),
      },
      {
        name: 'Download',
        path: '/download',
        component: () => import('../views/download/index'),
      },
    ],
  },
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/routers.js